import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { type PagePermissions, usePermission } from 'shared/hooks/use-permission';
import { useRouter } from 'shared/hooks/use-router';
import { useFirstAvailableRoute } from 'shared/hooks/use-first-available-route';
const hasPagePermission = (pagePermissions: PagePermissions, pathname: string): pathname is keyof PagePermissions => Object.hasOwn(pagePermissions, pathname);
export const useGuard = () => {
  const $ = _c(7);
  const router = useRouter();
  const {
    isReady,
    pagePermissions
  } = usePermission();
  const {
    firstAvailableRoute
  } = useFirstAvailableRoute();
  const {
    pathname
  } = router;
  let t0;
  let t1;
  if ($[0] !== firstAvailableRoute || $[1] !== isReady || $[2] !== pagePermissions || $[3] !== pathname || $[4] !== router) {
    t0 = () => {
      if (!pathname || !isReady) {
        return;
      }
      if (!hasPagePermission(pagePermissions, pathname)) {
        return;
      }
      if (pagePermissions[pathname]) {
        return;
      }
      router.replace(firstAvailableRoute);
    };
    t1 = [isReady, pagePermissions, pathname, firstAvailableRoute, router];
    $[0] = firstAvailableRoute;
    $[1] = isReady;
    $[2] = pagePermissions;
    $[3] = pathname;
    $[4] = router;
    $[5] = t0;
    $[6] = t1;
  } else {
    t0 = $[5];
    t1 = $[6];
  }
  useEffect(t0, t1);
};